export default {
  list: {
    title: "Aktivitäten",
    descriptionAdmin:
      "Aktivitäten für Verkäufer und Hosts anzeigen und erstellen",
    descriptionPartner:
      "Ihre Aktivitäten, Dienstleistungen und Angebote verwalten",
    newActivity: "Neue Aktivität",
    loading: "Aktivitäten werden geladen…",
    emptyTitle: "Keine Aktivitäten gefunden",
    emptyDescription: "Sie haben noch keine Aktivitäten.",
    emptyDescriptionAdmin:
      "Erstellen Sie eine Aktivität für einen Verkäufer oder Host, um zu beginnen.",
    createFirst: "Erste Aktivität erstellen",
    createdToast: "Aktivität erfolgreich erstellt!",
    errorLoad: "Aktivitäten konnten nicht geladen werden",
    filterAria: "Aktivitäten filtern",
    filterAll: "Alle",
    filterVisible: "Sichtbar",
    filterHidden: "Ausgeblendet",
    searchPlaceholder: "Nach Name oder Stadt suchen…",
    noMatchesTitle: "Keine passenden Aktivitäten",
    noMatchesDescription: "Versuche eine andere Suche oder zeige alle Aktivitäten.",
    showAll: "Alle anzeigen",
  },
  detail: {
    updatedToast: "Aktivität erfolgreich aktualisiert!",
    serviceCategoriesUpdated: "Dienstleistungskategorien aktualisiert",
    back: "Zurück zu Aktivitäten",
    goToPartner: "Zum Partner",
    staffPanelTitle: "Staff-Einstellungen",
    adminEditingBanner:
      "Du bearbeitest diese Storefront als Staff. Änderungen gelten für das Live-Angebot des Verkäufers.",
    adminCommissionTitle: "Plattformprovision",
    adminOnlyBadge: "Nur Staff",
    adminCommissionHint:
      "Prozentsatz, den die Plattform von Buchungen dieser Aktivität behält. Verkäufer sehen diesen Bereich nicht.",
    adminCommissionPercentAria: "Provisionsprozentsatz für diese Aktivität",
    adminCommissionPercentInvalid: "Geben Sie einen gültigen Prozentsatz ein.",
    adminCommissionEdit: "Ändern",
    adminCommissionToastSaved: "Provision aktualisiert.",
    adminCategoryTitle: "Aktivitätstyp",
    adminCategoryHint:
      "Ob dieser Eintrag ein Restaurant, eine Attraktion oder eine Dienstleistung ist. Verkäufer können dies nicht ändern.",
    adminCategoryToastSaved: "Aktivitätstyp aktualisiert.",
    adminSalesAgentTitle: "Vertriebsagent",
    adminSalesAgentEmpty: "Nicht zugewiesen",
    adminSalesAgentChange: "Ändern",
    adminSalesAgentAssign: "Zuweisen",
    adminSalesAgentToastSaved: "Vertriebsagent-Zuweisung aktualisiert.",
    adminSalesAgentPercentInvalid:
      "Geben Sie einen gültigen Provisionsprozentsatz ein.",
    adminSalesAgentModalAssignTitle: "Vertriebsagent zuweisen",
    adminSalesAgentModalReassignTitle: "Vertriebsagent ändern",
    adminPromoTitle: "Promo-Rabatt",
    adminPromoActive: "Aktiv",
    adminPromoEnabled: "Promo aktiviert",
    adminPromoHint:
      "Legen Sie die minimale Plattformmarge für diese Aktivität fest. Der Rabatt kommt vollständig aus der Plattformmarge — alle anderen Parteien werden bezahlt, als gäbe es keinen Rabatt. Der tatsächliche Rabatt variiert je Artikel und Struktur.",
    adminPromoMarginMode: "Mindestmargen-Modus",
    adminPromoMarginModeAbsolute: "Fester Betrag",
    adminPromoMarginModePercentage: "Prozentsatz der Maximalmarge",
    adminPromoMarginValueAbsolute: "Minimale Plattformmarge (€)",
    adminPromoMarginValuePercentage: "Mindestmarge (% der Maximalmarge)",
    adminPromoItemColumn: "Artikel",
    adminPromoPreviewHint:
      "Rabatte variieren je Artikel und Struktur. Die Werte unten gelten pro Artikel über alle erreichbaren Strukturen.",
    adminPromoPreviewLoading: "Vorschaudaten werden geladen…",
    adminPromoNoItems:
      "Fügen Sie Katalogartikel hinzu, um die resultierenden Rabatte in der Vorschau zu sehen.",
    adminPromoMaxMargin: "Max. Marge",
    adminPromoMinDiscount: "Min. Rabatt",
    adminPromoMedianDiscount: "Median-Rabatt",
    adminPromoMaxDiscount: "Max. Rabatt",
    adminPromoOverrideColumn: "Überschreibung",
    adminPromoAddOverride: "Überschreiben",
    adminPromoRemoveOverride: "Überschreibung entfernen",
    adminPromoSave: "Promo speichern",
    adminPromoRemove: "Promo entfernen",
    adminPromoToastSaved: "Promo gespeichert.",
    adminPromoToastRemoved: "Promo entfernt.",
    headerCommission: "Provision {{percent}}",
    openStaffTab: "Staff-Einstellungen öffnen",
    adminActiveTitle: "Aktivität aktiv",
    adminSalesAgentHint: "Agent, der diese Aktivität vermittelt hat, und seine Provision.",
    adminPromoNotConfigured: "Nicht eingerichtet",
    adminPromoPaused: "Pausiert",
    adminPromoPreviewTitle: "Rabattvorschau pro Artikel",
    adminPromoPreviewEmpty: "Gib oben eine gültige Mindestmarge ein, um den Rabatt für jeden Artikel zu berechnen.",
    adminPromoPreviewError: "Die Rabattvorschau konnte nicht berechnet werden. Versuche es gleich noch einmal.",
    adminPromoPriceColumn: "Preis",
    adminPromoOverrideCount_one: "{{count}} Override",
    adminPromoOverrideCount_other: "{{count}} Overrides",
    adminCatalogImportTitle: "Katalog aus PDF importieren",
    adminCatalogImportBarHint:
      "Artikel und Labels aus einem PDF extrahieren (auch Scans), dann prüfen.",
    adminCatalogImportOpen: "PDF importieren",
    adminCatalogImportHint:
      "Beliebiges PDF-Menü oder -Katalog hochladen — digital oder gescannt. Zuerst Labels prüfen, dann Artikeln aus dem Dropdown zuweisen. Labels werden bei Bestätigung an der Aktivität gespeichert.",
    adminCatalogImportFileLabel: "Nur PDF",
    adminCatalogImportDropHint: "Klicken, um ein PDF auszuwählen",
    adminCatalogImportExtract: "Artikel extrahieren",
    adminCatalogImportSave: "Artikel speichern",
    adminCatalogImportCancel: "Verwerfen",
    adminCatalogImportChooseAnother: "Anderes PDF wählen",
    adminCatalogImportPreviewCount: "{{count}} Artikel zur Prüfung",
    adminCatalogImportLabelsTitle: "Labels",
    adminCatalogImportLabelsHint:
      "Aus dem PDF und dieser Aktivität. Umbenennen aktualisiert jeden Artikel mit diesem Label. Jederzeit neue hinzufügen.",
    adminCatalogImportLabelsEmpty:
      "Noch keine Labels. Fügen Sie eines hinzu, um es Artikeln zuzuweisen.",
    adminCatalogImportAddLabelPlaceholder: "Neuer Labelname",
    adminCatalogImportRemoveLabel: "Label entfernen",
    adminCatalogImportLabelNameRequired: "Jedes Label benötigt einen Namen.",
    adminCatalogImportLabelDuplicate: "Dieses Label existiert bereits.",
    adminCatalogImportLabelMissing:
      "Ein Artikel verweist auf ein entferntes Label.",
    adminCatalogImportLabelUntitled: "(ohne Titel)",
    adminCatalogImportName: "Name",
    adminCatalogImportCategory: "Label",
    adminCatalogImportCategoryNone: "Kein Label",
    adminCatalogImportDescription: "Beschreibung",
    adminCatalogImportPrice: "Preis (€)",
    adminCatalogImportRemoveRow: "Artikel entfernen",
    adminCatalogImportPickFile: "Wählen Sie zuerst eine PDF-Datei.",
    adminCatalogImportEmptyPreview:
      "Keine Artikel zum Speichern. Erneut extrahieren oder verwerfen.",
    adminCatalogImportNameRequired: "Jeder Artikel benötigt einen Namen.",
    adminCatalogImportPriceInvalid:
      "Geben Sie einen gültigen nicht-negativen Preis ein.",
    adminCatalogImportTranslatedBanner:
      "Text wurde zu {{language}} zur Prüfung übersetzt. Erkannte Quelle: {{source}}.",
    adminCatalogImportToastExtracted:
      "{{count}} Artikel extrahiert. Vor dem Speichern prüfen.",
    adminCatalogImportToastSaved: "{{count}} Artikel zum Katalog hinzugefügt.",
    visibilityLabel: "Katalogsichtbarkeit",
    visibilityHint:
      "Ein: im Katalog sichtbar, wenn die Aktivität aktiv ist. Aus: ausgeblendet, keine neuen Buchungen. Speichern zum Anwenden.",
    visibilityToggleAria: "Diese Aktivität im Katalog ein- oder ausblenden",
    visibilityLockedHint:
      "Vervollständigen Sie Ihr rechtliches Profil in den Einstellungen, bevor Sie diese Aktivität sichtbar machen können.",
    adminActiveHint:
      "Nur Staff. Wenn aus, können Partner die Aktivität nicht öffnen und sie erscheint nie im Katalog.",
    adminActiveToggleAria: "Diese Aktivität aktivieren oder deaktivieren (Staff)",
    adminActiveToastSaved: "Aktiver Status der Aktivität aktualisiert.",
    profileIncompleteBanner:
      "Ihr rechtliches Profil ist unvollständig. Diese Aktivität kann erst im Kundenkatalog erscheinen, wenn Ihr Profil vollständig ist.",
    profileIncompleteModalTitle: "Rechtliches Profil vervollständigen",
    profileIncompleteModalMessage:
      "Diese Aktivität kann Kunden erst angezeigt werden, wenn Ihr rechtliches Profil vollständig ist. Gehen Sie zu Einstellungen, um die erforderlichen Angaben auszufüllen, oder bearbeiten Sie weiter und vervollständigen Sie Ihr Profil später.",
    profileIncompleteModalGoToProfile: "Zum Profil",
    profileIncompleteModalLater: "Später erledigen",
    partnerShareBadge: "{{percent}} % pro Buchung",
    partnerShareHint:
      "Ihr vereinbarter Anteil an jeder Buchung für diese Aktivität mit Flitrip.",
    untitledActivity: "Unbenannte Aktivität",
    loading: "Aktivität wird geladen…",
    notFoundMessage:
      "Die angeforderte Aktivität existiert nicht oder Sie haben keine Berechtigung, sie anzuzeigen.",
    inactiveAdminBanner:
      "Diese Aktivität ist inaktiv. Partner sehen sie in der Liste, können sie aber erst öffnen, wenn Sie sie aktivieren.",
    hiddenBanner:
      "Diese Aktivität ist im Katalog ausgeblendet. Schalten Sie die Sichtbarkeit ein und speichern Sie, um sie wieder anzuzeigen.",
    tabs: {
      ariaLabel: "Einrichtungsbereiche der Aktivität",
      general: "Allgemein",
      generalDesc: "Name, Standort und Medien",
      generalHeading: "Allgemein & Storefront",
      generalHint:
        "Name und Beschreibung in allen unterstützten Sprachen, Standort, Bilder und Einstellungen. Profiländerungen mit der Leiste unten speichern.",
      availability: "Verfügbarkeit",
      availabilityDesc: "Wöchentliche Zeiten und Ausnahmen",
      availabilityHeading: "Verfügbarkeit",
      availabilityHint:
        "Wöchentliche Zeitfenster und Ausnahmen für Feiertage oder Sondertage festlegen. Änderungen werden sofort gespeichert.",
      configuration: "Konfiguration",
      configurationDesc: "Aktivitätseinstellungen, Menü und Dienstleistungen",
      configurationHeading: "Aktivitätskonfiguration",
      configurationHint:
        "Kategoriespezifische Einstellungen, Menüartikel oder Dienstleistungskatalog. Die meisten Änderungen werden bei Bestätigung sofort gespeichert.",
      preview: "Vorschau",
      previewDesc: "Tablet-Storefront-Ansicht",
      previewHeading: "Storefront-Vorschau",
      previewHint:
        "So erscheint diese Aktivität auf dem Tablet vor Ort. Buchungsaktionen sind in der Vorschau deaktiviert.",
      staff: "Staff",
      staffDesc: "Provision, Agent und Promo",
      staffHeading: "Staff-Einstellungen",
      staffHint: "Nur für Staff sichtbar. Jeder Block wird einzeln gespeichert.",
    },
    preview: {
      title: "Storefront-Vorschau",
      disclaimer:
        "Dies ist eine schreibgeschützte Vorschau der öffentlichen Katalogseite. Speichern Sie Profiländerungen auf anderen Tabs, bevor Sie Updates hier prüfen.",
      openInNewTab: "In neuem Tab öffnen",
    },
  },
  detailForm: {
    catalogCopyTitle: "Name & Beschreibung",
    descriptionTitle: "Beschreibung",
    nameTitle: "Name",
    nameLanguageCardAria: "Name in {{language}} bearbeiten",
    descriptionPlaceholder:
      "Beschreiben Sie Ihre Aktivität, die angebotenen Dienstleistungen und die Erlebnisse, die Kunden erwarten können…",
    descriptionHint:
      "Optional im Entwurf; in jeder Sprache erforderlich, bevor Sie sie sichtbar machen können",
    descriptionCustomerBanner:
      "Kunden sehen Katalogtexte in ihrer Sprache, wenn Name und Beschreibung in allen unterstützten Sprachen ausgefüllt sind.",
    descriptionLanguageCardAria: "Beschreibung in {{language}} bearbeiten",
    autoTranslateHint:
      "Name und Beschreibung sind in jeder Sprache erforderlich (Englisch, Spanisch, Italienisch, Deutsch). Füllen Sie mindestens eine Sprache aus und generieren Sie Übersetzungen. Nach einer Umbenennung erneut generieren, um die anderen Sprachen zu aktualisieren.",
    autoTranslateGenerate: "Übersetzungen generieren",
    locationTitle: "Standort",
    handshakeConfigTitle: "Buchungsbestätigung",
    requiresHandshake: "Handshake erforderlich",
    requiresHandshakeHint:
      "Wenn aktiviert, erfordern Buchungen eine Verkäuferbestätigung vor der Finalisierung. Kunden wählen ein Wunschdatum/-zeit und warten auf Ihre Freigabe.",
    noteStrong: "Hinweis:",
    handshakeNote:
      "Dienstleistungen dieser Aktivität nutzen die Öffnungszeiten der Aktivität für die Planung. Kunden können nur einen aktiven Handshake gleichzeitig haben.",
    handshakeNoteRestaurant:
      "Kunden müssen die Buchung mit Ihnen bestätigen, bevor die Reservierungsgebühr berechnet wird. Kunden können nur einen aktiven Handshake gleichzeitig haben.",
    bookingCutoffTitle: "Buchungsschluss",
    bookingCutoffHint:
      "Wie lange vor jedem Nur-Start-Zeitfenster Buchungen schließen müssen. Zeitfenster mit Endzeit bleiben bis zum Ende buchbar (Schluss gilt nicht).",
    bookingCutoffLeadTime: "Vorlaufzeit",
    bookingCutoffUnitLabel: "Einheit",
    bookingCutoffUnitMinutes: "Minuten",
    bookingCutoffUnitHours: "Stunden",
    bookingCutoffExample:
      "Beispiel: Ein 09:00-Zeitfenster mit 2 Stunden Vorlauf — Buchung ist bis 07:00 offen; danach nicht mehr verfügbar.",
  },
  weekdays: {
    monday: "Montag",
    tuesday: "Dienstag",
    wednesday: "Mittwoch",
    thursday: "Donnerstag",
    friday: "Freitag",
    saturday: "Samstag",
    sunday: "Sonntag",
  },
  schedule: {
    title: "Verfügbarkeitsplan",
    weeklyTitle: "Wochenplan",
    overridesTitle: "Plan-Ausnahmen",
    addOverride: "Ausnahme hinzufügen",
    noOverrides:
      "Keine Ausnahmen. Fügen Sie eine für Feiertage oder Sondertage hinzu.",
    noSlotsClosed: "Keine Zeitfenster (geschlossen)",
    addTimeSlot: "Zeitfenster hinzufügen",
    copyScheduleTitle: "Plan von {{day}} kopieren",
    pasteScheduleTitle: "Plan von {{day}} hier einfügen",
    deleteOverrideConfirm: "Diese Ausnahme löschen?",
    closedBadge: "Geschlossen",
    slotModal: {
      editTitle: "Zeitfenster bearbeiten",
      addTitle: "Zeitfenster hinzufügen",
      startRequired: "Startzeit ist erforderlich",
      startTimeLabel: "Startzeit",
      duplicateStartError:
        "Ein anderes Zeitfenster nutzt bereits diese Startzeit",
      startOnlyTitle: "Startzeit",
      startOnlySubtitle: "Eine Uhrzeit",
      startOnlyHint:
        "Gäste können dieses Zeitfenster bis zur Startzeit buchen. Bei gesetztem Buchungsschluss schließt es so viele Minuten vorher.",
      windowTitle: "Zeitfenster",
      windowSubtitle: "Start und Ende",
      windowHint:
        "Gäste können dieses Zeitfenster bis zur Endzeit buchen. Buchungsschluss gilt nicht.",
      endTimeLabel: "Endzeit",
      endRequired: "Endzeit ist für ein Zeitfenster erforderlich",
      endAfterStart: "Endzeit muss nach der Startzeit liegen",
      overlapWarning:
        "Dieses Zeitfenster überschneidet sich mit einem anderen. Sie können es dennoch speichern.",
      maxCapacityLabel: "Max. Kapazität (optional)",
      maxCapacityPlaceholder: "Leer lassen für unbegrenzt",
      maxCapacityHint:
        "Maximale Anzahl verfügbarer Plätze in diesem Zeitfenster",
      mealTypeLabel: "Mahlzeit (optional)",
      breakfast: "Frühstück",
      lunch: "Mittagessen",
      dinner: "Abendessen",
      aperitif: "Aperitif",
      saveSlot: "Änderungen speichern",
      addSlot: "Zeitfenster hinzufügen",
    },
    overrideModal: {
      titleAdd: "Plan-Ausnahme hinzufügen",
      titleEdit: "Ausnahme bearbeiten",
      nameLabel: "Name",
      namePlaceholder: "z. B. Weihnachtsferien",
      from: "Von",
      to: "Bis",
      status: "Status",
      closedDuring: "In diesem Zeitraum geschlossen",
      markClosed: "Als geschlossen markieren",
      timeSlots: "Zeitfenster",
      addSlot: "Zeitfenster hinzufügen",
      noSlotsHint: "Keine Zeitfenster definiert. Nutzt Wochenplan, wenn leer.",
      saveChanges: "Änderungen speichern",
      addOverrideBtn: "Ausnahme hinzufügen",
      nameDateRequired: "Name und Datumsbereich sind erforderlich",
      endAfterStart: "Enddatum muss nach dem Startdatum liegen",
    },
    toast: {
      updated: "Plan aktualisiert",
      updateError: "Fehler beim Aktualisieren des Plans",
      overrideCreated: "Ausnahme erstellt",
      overrideCreateError: "Fehler beim Erstellen der Ausnahme",
      overrideUpdated: "Ausnahme aktualisiert",
      overrideUpdateError: "Fehler beim Aktualisieren der Ausnahme",
      overrideDeleted: "Ausnahme gelöscht",
      overrideDeleteError: "Fehler beim Löschen der Ausnahme",
      copiedDay: "Plan von {{day}} kopiert",
      slotOverlapWarning:
        "Dieses Zeitfenster überschneidet sich mit einem anderen. Es wurde dennoch gespeichert.",
    },
  },
  zod: {
    nameRequired: "Name ist in jeder Sprache erforderlich",
    descriptionRequired: "Beschreibung ist in jeder Sprache erforderlich",
    allTranslationsRequired: "Übersetzungen sind in jeder Sprache erforderlich",
    commissionPercentRequired: "Plattformprovision ist erforderlich",
    commissionPercentRange: "Geben Sie einen gültigen Prozentsatz ein.",
    categoryRequired: "Wählen Sie eine Katalogkategorie",
    paymentModelRequired: "Wählen Sie einen Zahlungstyp",
    bookingCutoffInvalid: "Geben Sie eine ganze Zahl ein (0 oder größer).",
    bookingCutoffRange:
      "Vorlaufzeit muss innerhalb der erlaubten Grenzen liegen (bis zu 7 Tage).",
  },
  card: {
    active: "Aktiv",
    inactive: "Inaktiv",
    hidden: "Ausgeblendet",
    notReadyYet: "Noch nicht bereit",
    inactiveBlocked:
      "Diese Aktivität ist noch nicht aktiv. Bitte versuchen Sie es später erneut.",
    partnerShare: "{{percent}} % pro Buchung",
  },
  header: {
    paymentModelUpfront: "Vorauszahlung",
    paymentModelReceiptBased: "Belegbasiert",
  },
  createModal: {
    title: "Neue Aktivität erstellen",
    owner: "Inhaber",
    regionLabel: "Zahlungsregion *",
    chooseRegion: "Region auswählen…",
    regionRequired: "Wählen Sie eine Zahlungsregion",
    searchOwnerLabel: "Verkäufer oder Host suchen",
    searchOwnerPlaceholder: "Zum Filtern tippen…",
    selectAccount: "Konto auswählen *",
    chooseOwner: "Inhaber wählen…",
    noOwnersError: "Fügen Sie zuerst einen Verkäufer oder Host hinzu",
    partnerSuffix: "(Verkäufer)",
    hostSuffix: "(Host)",
    catalogCategory: "Katalogkategorie",
    activityName: "Aktivitätsname",
    description: "Beschreibung",
    descriptionPlaceholder: "Beschreiben Sie Ihre Aktivität…",
    location: "Standort",
    commissionPercentLabel: "Plattformprovisionssatz (%)",
    salesAgent: "Vertriebsagent (Vertrag)",
    salesAgentSearchPlaceholder: "E-Mail eingeben zum Suchen…",
    salesAgentNoResults: "Keine Vertriebsagenten entsprechen Ihrer Suche.",
    paymentModel: "Zahlungstyp",
    paymentModelUpfront: "Vorauszahlung",
    paymentModelUpfrontDesc: "Kunden zahlen vor dem Besuch.",
    paymentModelReceiptBased: "Belegbasiert (Restaurant-Ablauf)",
    paymentModelReceiptBasedDesc:
      "Restaurant-Ablauf mit Beleg-Upload und Cashback.",
    createActivity: "Aktivität erstellen",
    wizardNext: "Weiter",
    wizardSkip: "Überspringen",
    wizardStepDetails: "Details",
    wizardStepSalesAgent: "Vertriebsagent",
    wizardStepCounter: "Schritt {{current}} von {{total}}",
    withoutLocation: "Ohne Standort",
    noLocationSelectedMessage: "Diese Aktivität hat keinen Standort.",
    wizardStep2Lead:
      "Wählen Sie einen Vertriebsagenten aus der Liste oder überspringen Sie, um ohne Agent fortzufahren.",
    salesAgentCutPercentLabel: "Vertriebsagent-Provision (%)",
    salesAgentCutRequired:
      "Geben Sie die Vertriebsagent-Provision ein, wenn ein Agent ausgewählt ist.",
    wizardStep3Lead:
      "Geben Sie eine Adresse für die Geokodierung ein oder markieren Sie die Aktivität als ohne festen Standort.",
    salesAgentListEmpty: "Keine Vertriebsagenten verfügbar.",
  },
  adminCreate: {
    back: "Zurück zu Aktivitäten",
    backToPartner: "Zurück zum Verkäufer",
    backToHost: "Zurück zum Host",
  },
  restaurantConfig: {
    title: "Restaurant-Konfiguration",
    cuisineTypes: "Küchentypen",
    cuisinePlaceholder: "Küchentypen auswählen…",
    cuisineHint: "Wählen Sie einen oder mehrere Küchentypen",
    avgPriceLabel: "Durchschnittspreis pro Person (€)",
    avgPriceHint: "Durchschnittliche Kosten pro Person in Euro",
    avgPricePlaceholder: "25",
  },
  serviceCategories: {
    title: "Dienstleistungskategorien",
    addCategory: "Kategorie hinzufügen",
    emptyTitle: "Noch keine Kategorien",
    emptyDescription:
      "Erstellen Sie Kategorien, um Ihre Dienstleistungen zu organisieren",
    emptyTitleMenu: "Standardgänge sind bereit",
    emptyDescriptionMenu:
      "Vorspeise, erster Gang und die anderen Standardgänge bleiben beim Hinzufügen von Gerichten verfügbar. Fügen Sie hier nur eine Kategorie hinzu, wenn Sie eine zusätzliche Gruppierung benötigen.",
    standardCoursesHint:
      "Standard-Menügänge bleiben beim Hinzufügen von Gerichten verfügbar.",
    edit: "Kategorie bearbeiten",
    delete: "Kategorie löschen",
    modalEditTitle: "Kategorie bearbeiten",
    modalAddTitle: "Kategorie hinzufügen",
    nameLabel: "Kategoriename",
    namePlaceholder: "z. B. Massagen",
    saveChanges: "Änderungen speichern",
    allTranslationsRequired: "Name ist in jeder Sprache erforderlich",
    fillOneLanguageFirst:
      "Geben Sie den Kategorienamen in mindestens einer Sprache ein, bevor Sie Übersetzungen generieren.",
    autoTranslateHint:
      "Der Kategoriename ist in jeder Sprache erforderlich. Füllen Sie mindestens eine Sprache aus und generieren Sie Übersetzungen. Nach einer Umbenennung erneut generieren, um die anderen Sprachen zu aktualisieren.",
    autoTranslateGenerate: "Übersetzungen generieren",
    thisCategory: "diese Kategorie",
    deleteConfirm: "„{{name}}“ löschen?",
  },
  media: {
    saveChangesError: "Medienänderungen konnten nicht gespeichert werden",
    uploadedCount: "{{count}} Datei(en) hochgeladen",
    deleted: "Medium gelöscht",
    deleteFailed: "Datei konnte nicht gelöscht werden",
    arrowNavHint: "Pfeiltasten ← → zur Navigation",
    prevTitle: "Zurück (←)",
    nextTitle: "Weiter (→)",
    deleteConfirmTitle: "Medium löschen?",
    deleteConfirmMessage:
      "Diese Datei wird von der Aktivität entfernt. Dies kann nicht rückgängig gemacht werden.",
    sectionTitle: "Bilder und Videos",
    autoSaveBadge: "Speichert automatisch",
    sectionDescription:
      "Laden Sie Bilder und Videos hoch, die Kunden angezeigt werden. Miniaturansichten zum Sortieren ziehen.",
    emptyEditableTitle: "Bilder oder Videos hinzufügen",
    emptyEditableHint: "Klicken, um Dateien auszuwählen",
    emptyReadOnly: "Keine Medien verfügbar",
    thumbnailAlt: "Miniatur {{n}}",
    uploadingAlt: "Wird hochgeladen {{n}}",
    cropDescription:
      "Rahmen Sie das Foto für die Tablet-Galerie (16:9). Der gestrichelte Mittelbereich zeigt, was Startkarten behalten (4:3).",
  },
} as const;
